<template>
  <div>
    <b-button v-b-modal.create_report variant="primary" class="mb-3">
      <b-icon icon="upload" class="mr-2" />Create Report
    </b-button>
    <ReportForm />
  </div>
</template>

<script>
import ReportForm from "@/components/ReportForm";
export default {
  components: {
    ReportForm
  },
  methods: {
    showModal() {}
  }
};
</script>

<style>
</style>